@if (form) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12 gap-2" novalidate>
    <app-form-text-input [form]="form" [twoColumns]="true" id="code" label="CHOP.CODE"></app-form-text-input>
    <app-form-number-input
      [form]="form"
      [max]="200"
      [min]="0"
      [twoColumns]="true"
      id="altersVon"
      label="CHOP.ALTERS_VON"></app-form-number-input>
    <app-form-number-input
      [form]="form"
      [max]="200"
      [min]="0"
      [twoColumns]="true"
      id="altersBis"
      label="CHOP.ALTERS_BIS"></app-form-number-input>
    <app-form-text-input [form]="form" id="bezeichnung.De" label="GLOBAL.NAME_De"></app-form-text-input>
    <app-form-text-input [form]="form" id="bezeichnung.Fr" label="GLOBAL.NAME_Fr"></app-form-text-input>
    <app-form-text-input [form]="form" id="bezeichnung.It" label="GLOBAL.NAME_It"></app-form-text-input>
    <app-form-button-bar (onCancel)="cancel()" [form]="form" [saveDisabled]="submitting"></app-form-button-bar>
  </form>
}
